// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryNewMyOfficerInfoLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelOutput: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelCount: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelForce: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	spr_type: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    // update (dt) {}
}
